import { z } from 'zod';
export const workCategoryLeafSchema = z.object({
    id: z.string(),
    label: z.string(),
});
export const workSubCategorySchema = z.object({
    id: z.string(),
    label: z.string(),
    items: z.array(workCategoryLeafSchema),
});
export const workCategorySchema = z.object({
    id: z.string(),
    label: z.string(),
    subCategories: z.array(workSubCategorySchema),
});
export const workCategoriesSchema = z.array(workCategorySchema);
